<template>
  <div id="footer">
    <!-- PC端 -->
    <div class="logo hidden-xs">
      <div class="container">
        <div class="top">
          <div class="footer_tips">
            <p>与彩讯携手创造未来</p>
            <span>在这里我们将共同收获自豪感、价值感、归属感、获得感，期待您的加入！</span>
          </div>
          <p class="footer_btn">期待合作</p>
        </div>
      </div>
    </div>
    <!-- H5 端 -->
    <div class="logo visible-xs">
      <div class="top">
        <div class="footer_tips">
          <p>与彩讯携手创造未来</p>
          <span>在这里我们将共同收获自豪感、价值感、归属感、获得感，期待您的加入！</span>
        </div>
        <p class="footer_btn">期待合作</p>
      </div>
    </div>
    <!-- PC -->
    <div class="container hidden-xs">
      <div class="corporate_box">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="phone">
            <div>
              <img src="@/assets/img/footer/icon-phone.png" alt="">
              <p>服务热线：4008-303-123</p>
            </div>
            <span>法律声明 网站地图 联系我们</span>
          </div>
          <div class="code">
            <span>彩讯官方公众号<br />微信扫一扫进入<br />查看更多公司动态</span>
            <img src="@/assets/img/footer/qrcoder.png" alt="">
          </div>
        </div>
        <div style="color: rgba(0, 0, 0, 0.55);font-size: 12px; text-align: center;">
          <span>Copyright © 2017-2022广州彩讯数字技术有限公司 | 粤ICP备17090306号</span>
        </div>
      </div>
    </div>
    <!-- h5 -->
    <div id="corporate" class="visible-xs">
      <div class="corporate_box">
        <div style="display: flex;flex-flow: column;">
          <div class="phone">
            <div>
              <img src="@/assets/img/footer/icon-phone.png" alt="">
              <p>服务热线：4008-303-123</p>
            </div>
            <div class="statement">
              <p>法律声明</p>
              <p>网站地图</p>
              <p>联系我们</p>
            </div>
          </div>
          <div class="code">
            <span>彩讯官方公众号<br />微信扫一扫进入<br />查看更多公司动态</span>
            <img src="@/assets/img/footer/qrcoder.png" alt="">
          </div>
        </div>
        <div style="color: rgba(0, 0, 0, 0.55);font-size: .24rem;margin-top: .2rem;">
          <p>Copyright © 2017-2022广州彩讯数字技术有限公司</p>
          <p>粤ICP备17090306号</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped lang="less">
#footer {
  width: 100%;
  height: 100%;
  color: #000;
  background: #fff;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 100%;
  height: 174px;
  background: url(../assets/img/footer/footer_bg.png) 0 0 no-repeat;
  background-size: 100% 100%;
  display: flex;
  .top {
    display: flex;
    justify-content: space-between;
    height: 100%;
    align-items: center;
  }
  .footer_tips {
    color: #fff;
    display: flex;
    flex-flow: column;
    align-items: start;
    p {
      font-size: 40px;
      font-weight: 600;
    }
    span {
      font-size: 16px;
      padding-top: 15px;
    }
  }
  .footer_btn {
    background: #FF5500;
    padding: 12px 28px;
    color: #fff;
    border-radius: 4px;
  }
}
.corporate_box {
  padding: 30px 0;
  .phone {
    display: flex;
    flex-flow: column;
    align-items: start;
    div {
      display: flex;
      align-items: center;
      img {
        height: 24px;
        width: 24px;
      }
      p {
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 0 10px;
      }
    }
    span {
      font-size: 16px;
      padding-top: 10px;
    }
  }
  .code {
    display: flex;
    align-items: center;
    img {
      width: 90px;
      height: 90px;
    }
    span {
      text-align: left;
      color: rgba(0, 0, 0, 0.55);
      font-size: 12px;
      padding-right: 10px;
      line-height: 20px;
    }
  }
  .remark {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;
    div {
      display: flex;
      align-items: center;
    }
    img {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
    color: rgba(0, 0, 0, 0.55);
    font-size: 12px;
  }
}

@media screen and (max-width: 997px) {
  #footer {
    text-align: left;
  }
  .title {
    font-size: 0.4rem;
  }
  .logo {
    background: url(../assets/img/h5/footer_bg.png) 0 0 no-repeat;
    background-size: 100% 100%;
    height: 100%;
    .top {
      flex-flow: column;
      justify-content: start;
      align-items: start;
      padding: 0.4rem;
    }
    .footer_tips {
      p {
        font-size: 0.32rem;
      }
      span {
        font-size: 0.24rem;
        padding-top: 0;
      }
    }
    .footer_btn {
      margin-top: 0.4rem;
      margin-bottom: 0;
      padding: 0.2rem 0.5rem;
      font-size: 0.24rem;
    }
  }
  #corporate {
    padding: .4rem;
  }
  .corporate_box {
    padding: 0;
    .phone {
      div {
        img {
          height: .24rem;
          width: .24rem;
        }
        p {
          font-size: .24rem;
          font-weight: 600;
          margin: 0 0 0 .2rem;
        }
      }
      span {
        font-size: .32rem;
        padding-top: .2rem;
      }
      .statement {
        flex-flow: column;
        align-items: start;
        width: 100%;
        p {
          padding: .4rem 0 .2rem;
          margin: 0;
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
        }
      }
      
    }
    .code {
      justify-content: space-between;
      padding-top: .2rem;
      img {
        width: 1.8rem;
        height: 1.8rem;
      }
      span {
        text-align: left;
        color: rgba(0, 0, 0, 0.55);
        font-size: .24rem;
        padding-right: .2rem;
        line-height: .4rem;
      }
    }
    .remark {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 30px;
      div {
        display: flex;
        align-items: center;
      }
      img {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
      color: rgba(0, 0, 0, 0.55);
      font-size: 12px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue